import React from 'react';
import { GlobeIcon, CheckCircleIcon, CalendarIcon } from 'lucide-react';
export const InfoSection = () => {
  return <section id="about" className="py-20 bg-[#FAF9F5]" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="text-center mb-16" data-id="element-184">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-185">
            About New gTLDs
          </h2>
          <div className="w-24 h-1 bg-[#C4A44A] mx-auto mb-6" data-id="element-186"></div>
          <p className="text-xl text-[#5A5535] max-w-3xl mx-auto font-light leading-relaxed" data-id="element-187">
            Generic Top-Level Domains represent the next evolution in internet
            naming and branding.
          </p>
        </div>

        <div className="mb-16 bg-[#F7F5EE] border-l-4 border-[#C4A44A] shadow-sm p-8 md:p-10" data-id="element-188">
          <div className="flex items-start space-x-6" data-id="element-189">
            <div className="flex-shrink-0 bg-[#EDE9DB] p-3 rounded-full" data-id="element-190">
              <CalendarIcon className="h-8 w-8 text-[#5A5535]" data-id="element-191" />
            </div>
            <div data-id="element-192">
              <h3 className="text-2xl font-bold text-[#1E1D14] mb-3 font-serif" data-id="element-193">
                2026 Application Round
              </h3>
              <p className="text-[#3D3A25] mb-4 leading-relaxed" data-id="element-194">
                ICANN is opening the next round of new gTLD applications in
                2026. This represents a significant opportunity for
                organizations to secure their own custom domain extensions and
                establish their digital identity.
              </p>
              <p className="text-[#3D3A25] leading-relaxed" data-id="element-195">
                Building on the success of the 2012 round, which resulted in
                over 1,930 new gTLDs, the 2026 round will feature improved
                processes and updated policies based on lessons learned from the
                first round.
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-196">
          <div data-id="element-197">
            <h3 className="text-3xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-198">
              What Are gTLDs?
            </h3>
            <p className="text-[#3D3A25] mb-6 leading-relaxed" data-id="element-199">
              Generic Top-Level Domains (gTLDs) are extensions that appear at
              the end of a domain name, such as .com, .org, and .net. New gTLDs
              expand beyond these traditional options, allowing for more
              specific and branded extensions like .app, .tech, or even your own
              brand name.
            </p>
            <h3 className="text-3xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-200">
              What Are New gTLDs?
            </h3>
            <p className="text-[#3D3A25] mb-8 leading-relaxed" data-id="element-201">
              In 2012, ICANN (Internet Corporation for Assigned Names and
              Numbers) opened the first round of applications for new gTLDs,
              revolutionizing the domain name system. The upcoming 2026 round
              provides another opportunity for organizations to apply for and
              operate their own unique domain extensions.
            </p>
            <h3 className="text-3xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-202">
              What Are the Different Types of New gTLD Applications?
            </h3>
            <div className="space-y-4" data-id="element-203">
              <div className="flex items-start space-x-4" data-id="element-204">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-205">
                  1
                </span>
                <p className="text-[#3D3A25]" data-id="element-206">
                  <span className="font-bold text-[#1E1D14]" data-id="element-207">
                    General Application
                  </span>{' '}
                  — Regular, non-specialized applications.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-208">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-209">
                  2
                </span>
                <p className="text-[#3D3A25]" data-id="element-210">
                  <span className="font-bold text-[#1E1D14]" data-id="element-211">
                    Community gTLD
                  </span>{' '}
                  — For gTLDs operated for the benefit of a clearly delineated
                  community; may elect Community Priority Evaluation (CPE).
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-212">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-213">
                  3
                </span>
                <p className="text-[#3D3A25]" data-id="element-214">
                  <span className="font-bold text-[#1E1D14]" data-id="element-215">
                    Geographic Name Application
                  </span>{' '}
                  — For strings considered geographic (city, region, certain
                  country-related terms). Requires government support or
                  non-objection when applicable.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-216">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-217">
                  4
                </span>
                <p className="text-[#3D3A25]" data-id="element-218">
                  <span className="font-bold text-[#1E1D14]" data-id="element-219">
                    Reserved Name Application
                  </span>{' '}
                  — Only for specific eligible organizations (certain
                  IGOs/INGOs) applying for names held on the Reserved Names
                  list.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-220">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-221">
                  5
                </span>
                <p className="text-[#3D3A25]" data-id="element-222">
                  <span className="font-bold text-[#1E1D14]" data-id="element-223">
                    .Brand TLD Application
                  </span>{' '}
                  — For marks that match a registered trademark; includes
                  eligibility review and Specification 13 in the registry
                  agreement.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-224">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-225">
                  6
                </span>
                <p className="text-[#3D3A25]" data-id="element-226">
                  <span className="font-bold text-[#1E1D14]" data-id="element-227">
                    Internationalized Domain Name (IDN) Application
                  </span>{' '}
                  — For non‑ASCII scripts; must comply with IDNA2008 and Root
                  Zone LGR requirements.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-228">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-229">
                  7
                </span>
                <p className="text-[#3D3A25]" data-id="element-230">
                  <span className="font-bold text-[#1E1D14]" data-id="element-231">
                    Variant of an Existing gTLD
                  </span>{' '}
                  — For allocatable IDN variant(s) of an existing gTLD; only the
                  current registry operator may apply.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-232">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-233">
                  8
                </span>
                <p className="text-[#3D3A25]" data-id="element-234">
                  <span className="font-bold text-[#1E1D14]" data-id="element-235">
                    Primary IDN + Variant Set Application
                  </span>{' '}
                  — A new primary IDN gTLD plus up to four allocatable variant
                  strings submitted together in one application.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-236">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-237">
                  9
                </span>
                <p className="text-[#3D3A25]" data-id="element-238">
                  <span className="font-bold text-[#1E1D14]" data-id="element-239">
                    Government / IGO Applicant
                  </span>{' '}
                  — For applications submitted by governmental or
                  intergovernmental entities.
                </p>
              </div>
              <div className="flex items-start space-x-4" data-id="element-240">
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#5A5535] text-white text-xs font-bold flex items-center justify-center" data-id="element-241">
                  10
                </span>
                <p className="text-[#3D3A25]" data-id="element-242">
                  <span className="font-bold text-[#1E1D14]" data-id="element-243">
                    Applicant Support Application
                  </span>{' '}
                  — For applicants seeking financial assistance through the
                  Applicant Support Program (ASP).
                </p>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-244">
            <div className="absolute inset-0 bg-[#D4C88A] transform rotate-3 opacity-20" data-id="element-245"></div>
            <div className="absolute inset-0 bg-[#5A5535] transform -rotate-3 opacity-10" data-id="element-246"></div>
            <div className="relative bg-white p-10 shadow-xl border border-[#D4C88A]/30" data-id="element-247">
              <div className="flex justify-center mb-8" data-id="element-248">
                <div className="p-5 bg-[#F7F5EE] rounded-full border border-[#D4C88A]/50" data-id="element-249">
                  <GlobeIcon className="h-12 w-12 text-[#5A5535]" data-id="element-250" />
                </div>
              </div>
              <h4 className="text-xl font-bold text-center mb-6 font-serif text-[#1E1D14]" data-id="element-251">
                Examples of New gTLDs
              </h4>
              <div className="grid grid-cols-2 gap-4" data-id="element-252">
                <div className="bg-[#FAF9F5] p-4 border border-[#EDE9DB] text-center hover:border-[#C4A44A] transition-colors" data-id="element-253">
                  <p className="font-serif text-[#5A5535] font-bold text-lg" data-id="element-254">
                    .app
                  </p>
                  <p className="text-xs text-[#3D3A25] uppercase tracking-wide mt-1" data-id="element-255">
                    For applications
                  </p>
                </div>
                <div className="bg-[#FAF9F5] p-4 border border-[#EDE9DB] text-center hover:border-[#C4A44A] transition-colors" data-id="element-256">
                  <p className="font-serif text-[#5A5535] font-bold text-lg" data-id="element-257">
                    .tech
                  </p>
                  <p className="text-xs text-[#3D3A25] uppercase tracking-wide mt-1" data-id="element-258">
                    For technology
                  </p>
                </div>
                <div className="bg-[#FAF9F5] p-4 border border-[#EDE9DB] text-center hover:border-[#C4A44A] transition-colors" data-id="element-259">
                  <p className="font-serif text-[#5A5535] font-bold text-lg" data-id="element-260">
                    .store
                  </p>
                  <p className="text-xs text-[#3D3A25] uppercase tracking-wide mt-1" data-id="element-261">
                    For e-commerce
                  </p>
                </div>
                <div className="bg-[#FAF9F5] p-4 border border-[#EDE9DB] text-center hover:border-[#C4A44A] transition-colors" data-id="element-262">
                  <p className="font-serif text-[#5A5535] font-bold text-lg" data-id="element-263">
                    .bank
                  </p>
                  <p className="text-xs text-[#3D3A25] uppercase tracking-wide mt-1" data-id="element-264">
                    For financial
                  </p>
                </div>
                <div className="bg-[#FAF9F5] p-4 border border-[#EDE9DB] text-center hover:border-[#C4A44A] transition-colors" data-id="element-265">
                  <p className="font-serif text-[#5A5535] font-bold text-lg" data-id="element-266">
                    .brand
                  </p>
                  <p className="text-xs text-[#3D3A25] uppercase tracking-wide mt-1" data-id="element-267">
                    Your company
                  </p>
                </div>
                <div className="bg-[#FAF9F5] p-4 border border-[#EDE9DB] text-center hover:border-[#C4A44A] transition-colors" data-id="element-268">
                  <p className="font-serif text-[#5A5535] font-bold text-lg" data-id="element-269">
                    .custom
                  </p>
                  <p className="text-xs text-[#3D3A25] uppercase tracking-wide mt-1" data-id="element-270">
                    Your choice
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};